export default __webpack_public_path__ + "static/media/Jimmy Patronis.927c0b9a.jpg";